import React,{useEffect} from 'react';
import { Mixpanel } from '@/utils/mixpanel';
import { getSitesStaticPaths, getSiteStaticProps } from '@/src/utils/pageUtils';
import SitePage from '@/src/components/SitePage';

import NotFound from "@/components/views/supportingPages/NotFound"
import SipjoyAppContext from "@/src/contexts/SipjoyAppContext"
import { getPageAppContextProps } from '@/src/contexts/SiteContext';

const termsPage = ({siteContext}) => {

  useEffect(() => {
    Mixpanel.track('Terms Page');
  });
  if (!siteContext) {
    console.error('Could not load site properties')
    return <NotFound/>
  }
  const termsPage = siteContext.site?.terms_page;

  if (!termsPage) {
    console.error('Terms page is not defined for this site')
    return <NotFound/>
  }
  if (termsPage?.theme) {
    siteContext.site.theme = termsPage.theme
  }

  return (
    <SipjoyAppContext siteContext={siteContext} {...getPageAppContextProps(termsPage)}>
      <SitePage content={termsPage} />
    </SipjoyAppContext>
  )
};

export default termsPage;



export async function getStaticProps({ params }) {
  return getSiteStaticProps({ params })
}

export async function getStaticPaths() {
  return getSitesStaticPaths();
}